import type {
  TSupervisorAdministrationEmailFieldName,
  TSupervisorAdministrationFormValues,
  TSupervisorAdministrationSection,
} from './types.ts';
import type { TGuaranteesSupervisorSegment } from '~/store/guarantees/types.ts';

export const buildSupervisorAdministrationEmailFieldName = (
  sectionId: string
): TSupervisorAdministrationEmailFieldName =>
  `supervisorAdministrationDraftEmails.${sectionId}`;

export const buildSupervisorAdministrationFormValues = (
  currentSupervisorAdministrationDraftEmails: Record<string, string> = {}
): TSupervisorAdministrationFormValues => ({
  draftEmails: {},
  supervisorAdministrationDraftEmails: currentSupervisorAdministrationDraftEmails,
});

export const hasDuplicateSupervisorAdministrationEmail = (
  users: TSupervisorAdministrationSection['users'],
  email: string
) => users.some((user) => user.email.trim().toLowerCase() === email.trim().toLowerCase());

export const mapGuaranteesSupervisorSegmentsToAdministrationSections = (
  segments: TGuaranteesSupervisorSegment[]
): TSupervisorAdministrationSection[] =>
  segments.map((segment) => ({
    id: segment.segment.id,
    title: segment.segment.displayName || segment.segment.id,
    users: segment.supervisors.map((supervisor) => ({
      id: supervisor.id,
      email: supervisor.email,
    })),
  }));
